
const RIGHT_CLICK_BUTTON = 2;

export function mouseUpFactory<T = HTMLElement>(eventHandler: () => void) {
  return function mouseUpHandler(event: React.MouseEvent<T>) {
    if(event.button !== RIGHT_CLICK_BUTTON) {
      eventHandler();
    }
  };
}
